import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import { useHeaderFooter } from '../../hooks';

import './index.scss';
import messages from './messages';

import termsOfUseBannerImg from '../../img/termsOfUse/legatum-terms-of-use-banner.jpg';

const TermsOfUse = ({ children }: { children: React.ReactNode }) => {
  const { headerContent, footerContent } = useHeaderFooter(children);
  const intl = useIntl();

  const emailLink = (chunks: React.ReactNode) => (
    <a className="mailto-link" href={`mailto:${chunks}`}>{chunks}</a>
  );

  return (
    <>
      <input type="hidden" id="anPageName" name="page" defaultValue="about" />
      <div className="container-center-horizontal">
        <div className="about screen contact">
          <div className="homepage ">
            {headerContent}
            <div className="overlap-group6">
              <div className="hero-image">
                <div className="overlap-group-1">
                  <div
                    className="overlap-group-item"
                    style={{
                      backgroundImage: `url("${termsOfUseBannerImg}")`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      backgroundBlendMode: 'overlay',
                      width: '100%',
                      height: '100%',
                    }}
                    role="img"
                    aria-label={intl.formatMessage(messages.termsBgAlt)}
                  />
                  <h1 className="about-us recklessneue-regular-normal-white-100-1px">
                    <span className="recklessneue-regular-normal-white-100-1px">
                      {intl.formatMessage(messages.termsOfUse)}{' '}
                    </span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="legatum-container the-course">
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section1Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section1Text)}
              </p>
            </div>
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section2Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section2Text)}
              </p>
            </div>
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section3Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section3Text)}
              </p>
            </div>
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section4Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section4Text)}
              </p>
            </div>
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section5Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section5Text)}
              </p>
            </div>
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section6Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section6Text)}
              </p>
            </div>
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section7Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section7Text)}
              </p>
            </div>
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section8Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section8Text, {
                  link: emailLink,
                })}
              </p>
            </div>
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.section9Title)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.section9Text, {
                  link: emailLink,
                })}
              </p>
            </div>
          </div>
          {footerContent}
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
